// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2376":"27542881","2804":"4d445127","3451":"5b5ba321","9282":"d146b5aa"}[chunkId] + ".chunk.css";
};